/* eslint-disable react/no-unstable-nested-components */
import React from 'react'
import { useAppSelector } from 'hooks/redux'
import Table, { TABLE } from 'components/organisms/TableV2'
import { SpinnerIcon } from 'components/organisms/Table/styles'
import DownloadSVG from 'assets/svg/DownloadSVG'
import { useDispatch } from 'react-redux'
import { addCommaZero } from 'utils/common'
import { getOperationIcon } from 'components/molecules/InvestmentActivityItem'
import {
  InvestmentOrderType,
  InvestmentOrderWithActivityData,
  InvestmentStatus
} from 'store/investments/types'
import { showDrawer } from 'store/drawer/actions'
import {
  ActivityContainer,
  CustomText,
  ExecutedTitle,
  MainTitle,
  Subtitle,
  TableWrapper,
  Wrapper
} from './styles'
import { formatDateWithMonthOptional } from '@qirapagos/lib/utils/common'
import { Drawers } from 'store/drawer/types'
import { selectInvestmentOrder } from 'store/investments/actions'
import { yellowFour, red } from '@qirapagos/web/src/theme/colors'

export const renderedTitle = ({
  movementType,
  status
}: {
  movementType: string
  status: number
}) => {
  const isSubscription = movementType === InvestmentOrderType.SUBSCRIPTION

  const executedTitle = isSubscription ? 'Suscribiste' : 'Rescataste'
  const mainTitle = isSubscription ? 'Suscripción' : 'Rescate'

  const getSubtitle = () => {
    switch (status) {
      case InvestmentStatus.Rejected:
        return { text: 'Rechazado', color: red }
      case InvestmentStatus.Canceled:
        return { text: 'Cancelado', color: red }
      case InvestmentStatus.Pending:
      case InvestmentStatus.ManualAction:
      case InvestmentStatus.NotSendedInvera:
        return { text: 'Pendiente', color: yellowFour }
      default:
        return null
    }
  }

  const subtitle = getSubtitle()

  if (status === InvestmentStatus.Executed) {
    return <ExecutedTitle>{executedTitle}</ExecutedTitle>
  }

  return (
    <Wrapper>
      <MainTitle>{mainTitle}</MainTitle>
      {subtitle && <Subtitle color={subtitle.color}>{subtitle.text}</Subtitle>}
    </Wrapper>
  )
}

const BoxMovementsInvestments: React.FC = () => {
  const { isLoading } = useAppSelector(state => state.transfers)
  const { orders, investmentClient } = useAppSelector(
    state => state.investments
  )

  const dispatch = useDispatch()

  const tableData: InvestmentOrderWithActivityData[] = orders.map(order => ({
    ...order,
    activityData: {
      type: order.type,
      status: order.statusId
    },
    account: investmentClient?.Client?.Accounts[0].number
  }))

  return (
    <TableWrapper>
      <Table
        data={tableData}
        title="Tenencias"
        icon={isLoading ? <SpinnerIcon /> : <DownloadSVG />}
        onClick={() =>
          dispatch(
            showDrawer(Drawers.FILTER_DATE, { fromInvestmentSummary: true })
          )}
        config={[
          {
            id: 'activityData',
            header: 'Actividad',
            meta: {
              formatter: (value: any) => (
                <ActivityContainer>
                  {getOperationIcon(value.type, value.status)}
                  {renderedTitle({
                    movementType: value.type,
                    status: value.status
                  })}
                </ActivityContainer>
              )
            }
          },
          {
            id: 'createdAt',
            header: 'Fecha',
            meta: {
              formatter: (value: Date) => (
                <CustomText>
                  {formatDateWithMonthOptional(value.toString())}
                </CustomText>
              )
            }
          },
          {
            id: 'amount',
            header: 'Monto',
            meta: {
              formatter: (value: any) => (
                <CustomText>
                  $
                  {value.toLocaleString('es-AR')}
                  {addCommaZero(value.toLocaleString('es-AR'))}
                </CustomText>
              )
            }
          },
          {
            id: TABLE.ACTION,
            header: '',
            meta: {
              actions: ({ row }: any) => [
                {
                  title: 'Ver detalle',
                  onPress: () => {
                    dispatch(selectInvestmentOrder(row.original))
                    dispatch(showDrawer(Drawers.INVESTMENT_DETAIL))
                  }
                }
              ]
            }
          }
        ]}
        isLoading={isLoading}
        emptyText="Aún no tienes inversiones registradas"
      />
    </TableWrapper>
  )
}

export default BoxMovementsInvestments
